import React from 'react';
import { useNavigate } from 'react-router-dom';
import { EnhancedNavigation } from '../components/navigation/EnhancedNavigation';
import { MobileBottomNav } from '../components/navigation/MobileBottomNav';
import { FeedbackModalProvider } from '../contexts/FeedbackModalContext';
import { PageControlsProvider } from '../contexts/PageControlsContext';

interface AuthLayoutProps {
  children: React.ReactNode;
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  const navigate = useNavigate();

  return (
    <PageControlsProvider>
      <FeedbackModalProvider enabled={false}>
        <div className="min-h-screen bg-transparent relative flex flex-col">
          <EnhancedNavigation
            user={null}
            onSignIn={() => navigate('/login')}
            onSignOut={() => navigate('/')}
          />

          <main className="relative pb-20 md:pb-0 flex-1">{children}</main>

          <MobileBottomNav user={null} />
        </div>
      </FeedbackModalProvider>
    </PageControlsProvider>
  );
};
